import styled from 'styled-components'

export const Footer = styled.footer`
  margin-top: auto;
  padding: 48px 32px;
  background-color: #fff;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    align-items: center;
  }
`

export const Legal = styled.p`
  font-size: 12px;
  line-height: normal;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const DesktopBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: inherit;
  line-height: 18px;

  @media (max-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    flex-direction: column;
  }
`

export const LegalRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints?.tablet}px) {
    flex-direction: column;
  }
`

export const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  line-height: inherit;
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
`

export const FooterLink = styled.a`
  line-height: inherit;
  color: inherit;
  text-decoration: none;
`

export const Copyright = styled.div`
  font-size: 16px;
  line-height: inherit;
  color: ${({ theme }) => theme.colors.textSecondary};
  text-align: center;
`

export const LanguageSelectWrapper = styled.div`
  position: relative;
  display: inline-flex;
`

export const LanguageTrigger = styled.button.attrs({ type: 'button' as const })<{
  $open: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  padding: 8px 12px;
  border: 1px solid ${({ $open, theme }) => ($open ? theme.colors.textSecondary : '#cbd5e1')};
  border-radius: 4px;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
`

export const LanguageChevron = styled.span<{ $open: boolean }>`
  display: inline-flex;
  flex-shrink: 0;
  rotate: ${({ $open }) => ($open ? '180deg' : '0deg')};
  transition: rotate 0.2s ease;
`

export const LanguageOptions = styled.div<{ $open: boolean }>`
  position: absolute;
  right: 0;
  bottom: calc(100% + 6px);
  z-index: 5;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 100%;
  max-height: 240px;
  overflow-y: auto;
  padding: 6px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease,
    transform 0.2s ease;
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: translateY(${({ $open }) => ($open ? 0 : '6px')});
`

export const LanguageOption = styled.button.attrs({ type: 'button' as const })`
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: none;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 14px;
  line-height: 20px;
  text-align: start;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: #f1f5f9;
  }

  &.active {
    color: #0f172a;
    font-weight: 600;
  }
`
